import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
// import NavigationView from '../views/NavigationView.vue'
import LoginView from '../views/LoginView.vue'
import LoginSysView from '../views/LoginSysView.vue'
import { useHistoryStore } from '@/store/history'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    children: [
      {
        path: 'main',
        name: 'main',
        component: () => import(/* webpackChunkName: "about" */ '../views/MainView.vue'),
        meta: {
          requireLogin: true,
          title: '首页',
          isHistory: false
        }
      },
      {
        path: 'products',
        name: 'products',
        component: () => import(/* webpackChunkName: "about" */ '../views/ProductListView.vue'),
        meta: {
          requireLogin: true,
          title: '产品管理',
          isHistory: true
        }
      },
      {
        path: 'product_add',
        name: 'product_add',
        component: () => import(/* webpackChunkName: "about" */ '../views/ProductAddView.vue'),
        meta: {
          requireLogin: true,
          title: '新增产品信息',
          isHistory: true
        }
      },
      {
        path: 'product_change',
        name: 'product_change',
        component: () => import(/* webpackChunkName: "about" */ '../views/ProductChangeView.vue'),
        meta: {
          requireLogin: true,
          title: '修改产品信息',
          isHistory: true
        }
      },
      {
        path: 'product_detail',
        name: 'product_detail',
        component: () => import(/* webpackChunkName: "about" */ '../views/ProductDetailView.vue'),
        meta: {
          requireLogin: true,
          title: '产品详情',
          isHistory: true
        }
      },
      {
        path: 'devices',
        name: 'devices',
        component: () => import(/* webpackChunkName: "about" */ '../views/DeviceListView.vue'),
        meta: {
          requireLogin: true,
          title: '设备管理',
          isHistory: true
        }
      },
      {
        path: 'remote_control',
        name: 'remote_control',
        component: () => import(/* webpackChunkName: "about" */ '../views/RemoteControl.vue'),
        meta: {
          requireLogin: true,
          title: '远程控制',
          isHistory: true
        }
      },
      {
        path: 'device_detail',
        name: 'device_detail',
        component: () => import(/* webpackChunkName: "about" */ '../views/DeviceDetailView.vue'),
        meta: {
          requireLogin: true,
          title: '设备详情',
          isHistory: true
        }
      },
      {
        path: 'device_config',
        name: 'device_config',
        component: () => import(/* webpackChunkName: "about" */ '../views/DeviceConfigView.vue'),
        meta: {
          requireLogin: true,
          title: '设备配置',
          isHistory: true
        }
      },
      {
        path: 'users',
        name: 'users',
        component: () => import(/* webpackChunkName: "about" */ '../views/UserListView.vue'),
        meta: {
          requireLogin: true,
          title: '用户管理',
          isHistory: true
        }
      },
      {
        path: 'user_add',
        name: 'user_add',
        component: () => import(/* webpackChunkName: "about" */ '../views/UserAddView.vue'),
        meta: {
          requireLogin: true,
          title: '新增用户信息',
          isHistory: true
        }
      },
      {
        path: 'user_change',
        name: 'user_change',
        component: () => import(/* webpackChunkName: "about" */ '../views/UserChangeView.vue'),
        // props: (route) => ({
        //   userId: route.params.userId,
        //   userName: route.params.userName,
        //   password: route.params.password,
        //   roleId: route.params.roleId,
        //   name: route.params.name,
        //   email: route.params.email,
        //   phone: route.params.phone,
        //   useState: route.params.useState,
        //   stateName: route.params.stateName,
        //   createdTime: route.params.createdTime,
        //   roleName: route.params.roleName,
        //   isDisable: route.params.isDisable
        // }),
        meta: {
          requireLogin: true,
          title: '修改用户信息',
          isHistory: true
        }
      },
      {
        path: 'user_detail',
        name: 'user_detail',
        component: () => import(/* webpackChunkName: "about" */ '../views/UserDetailView.vue'),
        // props: (route) => ({
        //   userId: route.params.userId,
        //   userName: route.params.userName,
        //   password: route.params.password,
        //   roleId: route.params.roleId,
        //   name: route.params.name,
        //   email: route.params.email,
        //   phone: route.params.phone,
        //   useState: route.params.useState,
        //   stateName: route.params.stateName,
        //   createdTime: route.params.createdTime,
        //   roleName: route.params.roleName,
        //   isDisable: route.params.isDisable
        // }),
        meta: {
          requireLogin: true,
          title: '用户信息详情',
          isHistory: true
        }
      },
      {
        path: 'map_manage',
        name: 'map_manage',
        component: () => import(/* webpackChunkName: "about" */ '../views/MapManageView.vue'),
        meta: {
          requireLogin: true,
          title: '地图管理',
          isHistory: true
        }
      },
      {
        path: 'ota_update',
        name: 'ota_update',
        component: () => import('../views/OTAUpdateView.vue'),
        meta: {
          requireLogin: true,
          title: 'OTA升级',
          isHistory: true
        }
      },
      {
        path: 'batch_upgrade',
        name: 'batch_upgrade',
        component: () => import('../views/BatchUpgradeView.vue'),
        meta: {
          requireLogin: true,
          title: '批量升级',
          isHistory: true
        }
      },
      {
        path: 'package_detail',
        name: 'package_detail',
        component: () => import('../views/PackageDetailView.vue'),
        meta: {
          requireLogin: true,
          title: '升级包详情',
          isHistory: true
        }
      },
      {
        path: 'login_log',
        name: 'login_log',
        component: () => import(/* webpackChunkName: "about" */ '../views/LoginLogView.vue'),
        meta: {
          requireLogin: true,
          title: '登录日志',
          isHistory: true
        }
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: {
      requireLogin: false,
      title: '关于',
      isHistory: false
    }
  },
  {
    path: '/profile',
    name: 'profile',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ProfileView.vue'),
    meta: {
      requireLogin: false,
      title: '个人中心',
      isHistory: false
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      requireLogin: false,
      title: '登录',
      isHistory: false
    }
  },
  {
    path: '/login_sys',
    name: 'login_sys',
    component: LoginSysView,
    meta: {
      requireLogin: false,
      title: '系统登录',
      isHistory: false
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

useHistoryStore.historyStack = []

router.afterEach((to) => {
  if (to.path === '/products' ||
    to.path === '/devices' ||
    to.path === '/users' ||
    to.path === '/om_tasks' ||
    to.path === '/faults' ||
    to.path === '/login_log') {
    useHistoryStore.historyStack = []
  }
  // console.log('stack:', useHistoryStore.historyStack, '----', to.meta?.title)
  if (to.meta?.isHistory === true) {
    let index = -1
    for (let i = 0; i < useHistoryStore.historyStack.length; i++) {
      console.log(useHistoryStore.historyStack[i]?.path, '==?', to.path)
      if (useHistoryStore.historyStack[i]?.path === to.path) {
        index = i
        break
      }
    }
    // console.log('index =', index)
    if (index === -1) {
      useHistoryStore.historyStack.push({
        path: to.path,
        name: to.meta.title,
        meta: to.meta
      })
    } else if (index >= 0) {
      console.log('==> index > 0')
      while (index < useHistoryStore.historyStack.length - 1) {
        useHistoryStore.historyStack.pop()
      }
    }
  }
})

export default router
